import { render, staticRenderFns } from "./ReceiverItemPage.vue?vue&type=template&id=5925d186&scoped=true&"
import script from "./ReceiverItemPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverItemPage.vue?vue&type=style&index=0&id=5925d186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5925d186",
  null
  
)

export default component.exports